<template>
	<div class="">
		<Top2 titletext="欢迎注册"></Top2>
		<div class="wd-theme-back reg">
			<div class="wd-container ">
				<div class="form ">
					<div class=" wd-theme-fff">
						<el-tabs value="first" type="border-card">
							<el-tab-pane label="用户注册" name="first">
								<div class="form2">
									<el-form label-width="90px" ref="regform">
										<el-form-item label="手机号码">
											<el-input maxlength="11" type="text" v-model="wddata.mobile" placeholder="请输入手机号码"></el-input>
										</el-form-item>
										<el-form-item label="验证码">
											<el-row>
												<el-col :span="16"><el-input placeholder="请输入验证码" maxlength="4" v-model="wddata.valcode"></el-input></el-col>
												<el-col :span="8"><s-identify :content-height="40" :identify-code="identifyCode" @click.native.prevent="refreshCode" /></el-col>
											</el-row>
										</el-form-item>
										<el-form-item label="短信验证码">
											<el-input maxlength="6" type="text" v-model="wddata.smscode" placeholder="请输入短信验证码"></el-input>
										</el-form-item>
										<el-form-item label="设置密码">
											<el-input maxlength="20" type="password" v-model="wddata.pass1" placeholder="请设置密码"></el-input>
										</el-form-item>
										<el-form-item label="确认密码">
											<el-input maxlength="20" type="password" v-model="wddata.pass2" placeholder="请输入确认密码"></el-input>
										</el-form-item>
										<el-form-item label="推荐人手机">
											<el-input maxlength="11" type="text" v-model="wddata.mobile2" placeholder="请输入推荐人手机"></el-input>
										</el-form-item>
										<el-form-item>
											<el-checkbox label="我已阅读并同意" name="type" v-model="wddata.xieyi"></el-checkbox>
											<span class="wd-theme">《用户使用协议》</span>
										</el-form-item>
										<div class="regbtn"><el-button type="primary" class="btn" @click="save">同意协议并注册</el-button></div>
									</el-form>
									<div class="hasreg">
										<span class="wd-theme-333 wd-m-r-10">我已注册？马上</span>
										<span class="wd-theme wd-cursor" @click="gotologin">登录</span>
									</div>
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Top2 from '@/components/layout/Top2.vue';
import Footer from '@/components/layout/Footer.vue';
import SIdentify from '@/components/Identify';
export default {
	name: 'Reg',
	components: {
		Top2,
		Footer,
		SIdentify
	},
	data() {
		return {
			adpic: 'https://www.peisong-ge.com/public/upload/ad/2018/04-13/4335611d9ab78af07e93ff2a31d2c895.jpg',
			wddata: {
				mobile: '',
				valcode: '',
				smscode: '',
				pass1: '',
				pass2: '',
				mobile2: '',
				xieyi:false
			},
			identifyCodes: '1234567890',
			identifyCode: ''
		};
	},
	methods: {
		// 生成一个随机数
		randomNum(min, max) {
			return Math.floor(Math.random() * (max - min) + min);
		},
		refreshCode() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
		},
		makeCode(o, l) {
			for (let i = 0; i < l; i++) {
				this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
			}
		},
		gotologin() {
			this.$router.push('./login');
		},
		save() {
			console.log(this.wddata);
			if (this.wddata.mobile == '') {
				this.$wd_msg('请输入手机号码');
				return;
			}
			if (this.wddata.valcode == '') {
				this.$wd_msg('请输入验证码');
				return;
			}
			if (this.wddata.valcode !== this.identifyCode) {
				this.$wd_msg('验证码输入错误');
				return;
			}
			if (this.wddata.pass1 == '') {
				this.$wd_msg('请输入密码');
				return;
			}
			if (this.wddata.pass1 !== this.wddata.pass2) {
				this.$wd_msg('2次密码输入不一致，请重新输入');
				return;
			}
			if (!this.wddata.xieyi){
				this.$wd_msg("注册会员需要阅读并同意协议");
				return;
			}
			var indata = this.wddata;
			indata.flag = 'web';
			indata.headpic = '';
			indata.name = '请设置昵称';

			this.$wd_request('memreg', indata)
				.then(data => {
					var tokentime = this.$weidajs.getDateTime();
					let ldata = {
						islogin: true,
						token: data.token,
						uuid: '',
						version: '',
						tokentime: tokentime,
						myinfo: data.value
					};
					sessionStorage.setItem('wdmem', JSON.stringify(ldata));
					this.$store.commit('login', ldata);
					this.$wd_toast("恭喜您，注册成功");
					this.$router.push('/member');
				})
				.catch(() => {
					this.refreshCode();
				});
		}
	},
	created() {
		this.refreshCode();
	}
};
</script>

<style lang="scss" scoped>
.reg {
	padding: 20px 150px;
	.form {
		padding: 0px 160px;
		.form2 {
			padding: 30px 160px;
			.xieyi {
			}
			.regbtn {
				margin-left: 90px;
				.btn {
					width: 100%;
				}
			}
			.hasreg {
				text-align: right;
				margin-top: 30px;
			}
		}
	}
}
</style>
